import React from "react";
import { Group } from "@visx/group";
import { GlyphCircle } from "@visx/glyph";
import { PRIMARY_COLOR } from "../Violinplot";

const circleSize = 24;
const height = 40;
const WHITE_COLOR = "#FFFFFF";

const OverlapMarker = ({ color = PRIMARY_COLOR, position }) => {
  return (
    <Group>
      <clipPath id="overlap1">
        <rect
          width={circleSize / 2}
          height={circleSize}
          transform={`translate(-${circleSize / 2}, -${circleSize / 2})`}
        ></rect>
      </clipPath>
      <GlyphCircle
        left={position}
        top={height / 2}
        size={circleSize * 10}
        fill={WHITE_COLOR}
        stroke={color}
        strokeWidth={2}
        clipPath="url(#overlap2)"
      />
      ) : (
        <GlyphCircle
          left={position}
          top={height / 2}
          size={circleSize * 10}
          clipPath={ "url(#overlap1)" }
          fill={color}
          stroke={color}
          strokeWidth={2}
          fillOpacity={1}
          strokeOpacity={1}
        />
      )}
    </Group>
  );
};
export default OverlapMarker;
